import React, { Component, Suspense } from 'react';
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchAgentInfo } from './store'; // Import action
import WebSocketHandler from './websocket';
import './scss/style.scss';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agentInfoLoaded: false, // agentInfo 로딩 상태 추적
    };
  }

  componentDidUpdate(prevProps) {
    const { token, agentInfo, fetchAgentInfo } = this.props;
    // Check ONLY if the token changed AND agentInfo is still null AND we HAVEN'T already loaded agentInfo
    if (token && !agentInfo && prevProps.token !== token && !this.state.agentInfoLoaded) {
      fetchAgentInfo();
    }

    // agentInfo 로딩 완료 상태 업데이트
    if (agentInfo && !this.state.agentInfoLoaded) {
      this.setState({ agentInfoLoaded: true });
    }
  }

  render() {
    const { token, agentInfo, rehydrated } = this.props;
    const { agentInfoLoaded } = this.state;

    if (!rehydrated) {
      return loading;
    }

    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <WebSocketHandler/>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/404" element={<Page404 />} />
            <Route path="/500" element={<Page500 />} />
            <Route
              path="*"
              element={token ? <DefaultLayout /> : <Navigate to="/login" replace />}
            />
          </Routes>
        </Suspense>
      </HashRouter>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
  agentInfo: state.auth.agentInfo,
  rehydrated: state._persist?.rehydrated ?? false,
});

const mapDispatchToProps = { fetchAgentInfo };

export default connect(mapStateToProps, mapDispatchToProps)(App);